import {kbUserData} from "../utils";
import {generateId, generateMsgId} from "./utils";
import {deepClone, getVPCService, publicChatData} from "../App/utils";
import {chatAddMessages} from "../API/chatAPI";
import {handleCreateChat} from "./handleCreateChat";

export const createSendMessage = ({
                                      isStreaming,
                                      setMessages,
                                      messages,
                                      RequestChatAPI,
                                      navigateToChat,
                                      setKBChats,
                                      itemsAreLoading,
                                      chatId,
                                      inputValue,
                                      setInputValue,
                                      uploadedImages = [],
                                      setUploadedImages = () => {},
                                      renderSettings
}) => {
    return async (props) => {
        let input = props?.injectedMessage || inputValue;

        // Apply message transform if provided (e.g., for adding filters/prefixes)
        if (input && renderSettings?.onBeforeSendMessage) {
            input = renderSettings.onBeforeSendMessage(input);
        }

        if (itemsAreLoading || isStreaming || (!input && uploadedImages.length === 0)) return;

        // Format content based on whether we have uploaded images
        let content = input;

        // If there are uploaded images, add them to the content
        if (uploadedImages.length > 0) {
            // Create an array of content objects
            let contentArray = [];

            // Add text if it exists
            if (input && input.trim() !== '') {
                contentArray.push({
                    type: "text",
                    text: input.trim()
                });
            }

            // so the LLM knows about the images in the message
            if (!renderSettings?.disableImageUploadText) {
                uploadedImages.forEach(url => {
                    url = url.replace('https://openkbs-files-raw.s3.amazonaws.com/', (getVPCService('file') || 'https://file.openkbs.com/'))
                    if (url?.toLowerCase()?.endsWith('.pdf')) {
                        contentArray.push({
                            type: "text",
                            text: `File Uploaded: ${url}`
                        });
                    } else {
                        contentArray.push({
                            type: "text",
                            text: `Image Uploaded: ${url}`
                        });
                    }

                });
            }

            // Add images
            uploadedImages.forEach(url => {
                contentArray.push({
                    type: "image_url",
                    image_url: {
                        url: url
                    }
                });
            });

            content = JSON.stringify(contentArray);
        }

        const newMessage = {
            role: 'user',
            content: content?.includes('"image_url"') ? content : input,
            userId: publicChatData ? `User_${generateId()}` : kbUserData().chatUsername,
            msgId: generateMsgId()
        };

        setInputValue('');
        // Clear uploaded images after sending
        setUploadedImages([]);

        if (props?.appendOnly) {
            setMessages((prev)=> [...prev, newMessage]);
        } else if (props?.toChatOnly) {
            setMessages((prev)=> [...prev, deepClone(newMessage)]);
            if (chatId) {
                chatAddMessages(chatId, [deepClone(newMessage)]).then()
            } else {
                handleCreateChat({chatMessages: [deepClone(newMessage)], navigateToChat, setKBChats})
            }
        } else {
            await RequestChatAPI([...messages, newMessage]);
        }
    }
}